<template>
  <div id="dashboard">
    <div id="leftmenu">
      <div>
        <div id="userMainDEC">
          <div id="userDec">
            <div id="profile-img">
              <img
                style="width: 64px;border-radius: 50%;height: 64px;"
                v-if="this.$store.getters.isAuthenticated && this.$store.state.userData && this.$store.state.userData.userProfilePic"
                :src="this.$store.state.userData.userProfilePic"
              />
              <img v-else src="../assets/svg/profiledark.svg" class="profileicon" />
            </div>
            <div id="user-name-parent">
              <span>
                <p class="head-profile">Hello,</p>
                <p
                  class="head-name"
                  v-if="this.$store.state.userData.orgname"
                >{{this.$store.state.userData.orgname}}</p>
                <p class="head-name" v-if="!this.$store.state.userData.orgname">User</p>
              </span>
              <span style="color:#4415e5">
                <a @click="()=>{this.$refs.inputFile.click()}">Change Profile Image</a>
              </span>
              <input
                style="visibility: hidden;position: absolute;"
                ref="inputFile"
                type="file"
                id="myFile"
                @change="uploadPic"
              />
            </div>
          </div>
        </div>

        <div id="userDesMenu">
          <div class="mainDiv">
            <div @click="showProfile" class="userOpt">
              <v-icon>person</v-icon>
              <div class="mainSel">ACCOUNT SETTINGS</div>
            </div>
            <div>
              <a @click="showProfile">
                <div class="subSel">Profile Information</div>
              </a>

              <a @click="showProfile">
                <div class="subSel">Company Information</div>
              </a>
            </div>
          </div>
          <div @click="showOrder" class="mainDiv active">
            <div class="userOpt">
              <v-icon>reorder</v-icon>
              <a class="mainSel">Order</a>
            </div>
          </div>
          <div @click="showWish" class="mainDiv">
            <div class="userOpt">
              <v-icon>favorite_border</v-icon>
              <a class="mainSel">My Wish List</a>
            </div>
          </div>
          <div @click="showNotification" class="mainDiv">
            <div class="userOpt">
              <v-icon>notifications_none</v-icon>
              <a class="mainSel">Notifications</a>
              <v-badge>
                <template v-slot:badge>
                  <span>{{notificationcount}}</span>
                </template>
              </v-badge>
            </div>
          </div>
          <div @click="showHelp" class="mainDiv">
            <div class="userOpt">
              <v-icon>help_outline</v-icon>
              <a class="mainSel">Help Center</a>
            </div>
          </div>
          <div @click="logOut" class="mainDiv">
            <div class="userOpt">
              <v-icon>power_settings_new</v-icon>
              <a class="mainSel">Logout</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="rightmenu">
      <div v-if="orders.length <= 0" class="empty-wishlist">
        <img
          v-if="orders.length <= 0"
          src="@/assets/svg/noorder.svg"
          alt
          style="width:50%;height:50%"
        />

        <H3 v-if="orders.length <= 0">Looks Like You Have No Orders Yet!!</H3>
      </div>

      <div @click="showproduct(s)" class="listed-ad-card" v-for="(s) in orders" :key="s.spaceid">
        <img @click="showproduct(c)" :src="s.img_url[0]" width="100%" height="50%" />
        <div class="status-card-verified">{{s.status}}</div>
        <span class="spaceid">Order ID:&nbsp;{{s.orderid}}</span>
        <v-btn color="warning">Invoice</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase";
import { db } from "../main";
import store from "../store";
export default {
  name: "Orders",
  components: {},
  data() {
    return {
      orders: []
    };
  },
  computed: {
    notificationcount() {
      let notifications = 0;
      this.$store.state.allproducts.forEach(e => {
        if (e.readuser == 0 && e.uid == this.$store.state.uid) {
          notifications = notifications + 1;
        }
      });
      return notifications;
    }
  },
  created() {
    db.collection("productspaces")
      .where("uid", "==", this.$store.state.uid)
      .onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === "added") {
            this.orders.push({
              ...change.doc.data(),
              id: change.doc.id
            });
          }
        });
      });
  },
  methods: {
    uploadPic() {
      var storage = firebase.storage();
      var file = document.getElementById("myFile").files[0];
      var storageRef = firebase.storage().ref();
      var thisRef = storageRef.child(
        file.name + this.$store.state.userData.uid + new Date()
      );
      if (file.size < 1024 * 1024) {
        thisRef.put(file).then(snapshot => {
          thisRef.getDownloadURL().then(url => {
            var promise = db
              .collection("orgdetails")
              .doc(this.$store.state.docId)
              .set(
                {
                  userProfilePic: url
                },
                { merge: true }
              )
              .then(() => {
                this.$bvToast.toast("Profile Upload Successfully", {
                  title: "Yheaaa !",
                  variant: "success",
                  solid: true,
                  toaster: "b-toaster-top-center",
                  appendToast: false
                });
              })
              .catch(() => {
                this.$bvToast.toast("Error in upload", {
                  title: "ohhh !",
                  variant: "warning",
                  solid: true,
                  toaster: "b-toaster-top-center",
                  appendToast: false
                });
              });
          });
        });
      } else {
        this.$bvToast.toast("Profile picture must less than 1 Mb", {
          title: "ohhh !",
          variant: "warning",
          solid: true,
          toaster: "b-toaster-top-center",
          appendToast: false
        });
      }
    },
    showproduct(selp) {
      this.$store.dispatch("selectedProduct", {
        sel: selp
      });
      this.$router.push({ name: "product", params: { Pid: selp.spaceid } });
      // router.push("/product");
    },
    showProfile() {
      this.$router.push("/profile");
    },
    showOrder() {
      this.$router.push("/orders");
    },
    showWish() {
      this.$router.push("/wishlist");
    },
    showNotification() {
      this.$router.push("/notification");
    },
    showHelp() {
      this.$router.push("/help");
    },
    logOut() {
      this.$store.state.user = null;
      this.$store.state.usertype = null;
      this.$store.state.uid = null;
      this.$store.state.isAuthenticated = false;
      this.$store.state.selproduct = [];
      // this.$store.state.selcategory = null;
      this.$store.state.categories = [];
      this.$store.state.products = [];
      this.$store.state.userData = [];
      this.$store.state.cartData = [];
      this.$store.state.checkout = [];
      this.$store.state.docId = null;
      this.$store.state.totalcartprice = null;
      this.$store.state.localCart = [];
      this.$store.state.localCartCount = [];
      this.$store.state.filterProduct = null;
      this.$store.state.selectedCat = null;
      this.$store.dispatch("userSignOut");
    }
  }
};
</script>
<style scoped>
@media only screen and (min-width: 700px) {
  #profile-img {
    display: flex;
    align-items: center;
  }
  #user-name-parent {
    display: flex;
    flex-flow: column;
    width: 100%;
  }
  #user-name-parent span {
    display: flex;
    flex-direction: row;
  }
  #user-name-parent a {
    margin-left: 10px;
  }
  .empty-wishlist {
    height: 70vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .active {
    background: #f3ededd1;
  }
  .userNameHello {
    padding: 5px 0 0 16px;
  }
  .row {
    display: flex;
    flex-flow: row;
  }
  .subSel {
    font-size: 14px;
    padding: 12px 5px 12px 66px;
    cursor: pointer;
    font-weight: 500;
  }

  .subSel:hover {
    color: #2874f0;
    background-color: #f5faff;
  }
  .mainSel {
    padding: 0 0 12px 20px;
    font-size: 16px;
    font-weight: 500;
    color: #878787;
  }
  .mainDiv {
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
  }
  .userOpt {
    padding: 20px 12px 5px 24px;
    display: flex;
  }
  .row {
    flex-flow: row wrap;
    text-align: center;
  }
  #dashboard {
    display: flex;
    flex-flow: row wrap;
    margin: 0 auto;
    position: relative;
    justify-content: center;
    width: 90%;
    margin-top: 85px;
    margin-bottom: 20px;
  }
  #leftmenu {
    width: 25%;
  }
  #rightmenu {
    display: flex;
    justify-content: center;
    width: 65%;
    flex-flow: row;
    flex-wrap: wrap;
    background: white;
    /* border-radius: 10px; */
    margin-left: 15px;
    padding: 10px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16), 0 2px 2px rgba(0, 0, 0, 0.23);
  }

  #userMainDEC {
    display: flex;
    height: 6rem;
    background: white;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16), 0 2px 2px rgba(0, 0, 0, 0.23);
    display: flex;
    width: 100%;
    padding-left: 10px;
    padding-right: 5px;
  }
  #userDec {
    display: flex;
    flex-direction: row;
    margin: auto;
    width: 100%;
  }

  #userDec img {
    margin-right: 10px;
  }
  #userDec p {
    margin-left: 10px;
    margin-bottom: 0;
  }
  #userDec p:nth-of-type(1) {
    margin-bottom: 5px;
  }
  #userDesMenu {
    margin-top: 15px;
    background: white;
    /* border-radius: 10px; */
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.16), 0 3px 4px rgba(0, 0, 0, 0.23);
  }
  .listed-ad-card {
    display: flex;
    flex-direction: column;
    height: 20rem;
    width: 19rem;
    min-width: 14rem;
    background: white;
    margin: 1rem;
    cursor: pointer;
    align-items: center;
    text-align: center;
    border: 1px solid bisque;
  }
  .status-card-verified {
    background-color: #2b44ff;
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: white;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    margin-top: -0.5rem;
    margin-bottom: 1rem;
  }
  .profileicon {
    width: 3rem;
  }
  .head-profile {
    font-size: 1.625rem;
    font-weight: bold;
  }
  .head-name {
    font-size: 1.625rem;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 600px) {
  #leftmenu {
    display: none;
  }
  #rightmenu {
    margin-top: 35px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    background: white;
    justify-content: center;
    padding: 25px 0;
  }

  .infoI {
    position: absolute;
    right: 0;
  }
  #submitBtn {
    text-align: center;
  }
  .listed-ad-card {
    display: flex;
    flex-direction: column;
    height: 13rem;
    width: 10rem;
    background: white;
    margin: 1rem;
    cursor: pointer;
    align-items: center;
    text-align: center;
    border: 1px solid bisque;
  }
}
</style>


